import { Icon } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const ModalBody = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  overflow-y: hidden;
  text-align: center;

  ${Icon?.S?.Icon} {
    border: 3px solid var(--color-success-default);
    border-radius: 100%;
  }
`;

export { ModalBody };
